import _ from 'lodash';

type Settings = Record<string, unknown>;

// The settled value for each field a write set, kept only while that field still holds what the write put
// there, so a change made while the write was in flight is never overwritten. Fields `settled` lacks stay.
export const pickSettledSettings = ({ current, written, settled }: { current?: Settings; written: Settings; settled?: Settings }): Settings => (
  _.pickBy(
    _.pick(settled || {}, Object.keys(written)),
    (value, key) => _.isEqual(current?.[key], written[key]),
  )
);

// A write's rollback target: each field it set, as it was before, including fields that were unset.
export const settingsBeforeWrite = ({ before, written }: { before?: Settings; written: Settings }): Settings => (
  _.fromPairs(Object.keys(written).map((key) => [key, before?.[key]]))
);
